import { InputStyled } from 'ui-toolkit';

/*tslint:disable-next-line*/
import ReactInputMask from 'react-input-mask';
import styled from 'styled-components';

const TimeInputStyled = styled(InputStyled.withComponent(ReactInputMask))`
  text-transform: uppercase;
`;

export default TimeInputStyled;
